export const URL_APP = {
  MANUAL_USUARIO: 'https://manual.portalcliente-cendiatra.com',
}
